import { COLLECTIONS } from "constants/action-types";
import {
    IDisplayPreference,
    IMerchantDisplayPreference,
} from "components/product-collection/product-collection-views/product-collection-grid-view/tool-panels/data-view-panel";
import { List, Map } from "immutable";

export const DEFAULT_VIEW_NAME = "Default";
export const DEFAULT_MASTER_VIEW_NAME = "DEFAULT_MASTER_VIEW_NAME";

export const addItemDisplayPreferences = (id: string, displayPreference: IDisplayPreference, index = 0) => ({
    payload: {
        id,
        displayPreference,
        index,
    },

    type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.IITEMDISPLAYPREFERENCE.ADD.START,
});

export const removeItemDisplayPreferences = (id: string, index: number) => ({
    payload: { id, index },

    type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.IITEMDISPLAYPREFERENCE.REMOVE.START,
});

export const editItemDisplayPreference = (id: string, index: number, displayPreference: IDisplayPreference) => ({
    payload: { id, index, displayPreference },

    type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.IITEMDISPLAYPREFERENCE.EDIT.START,
});

export const fetchMerchantItemDisplayPreferences = (merchantId: string) => ({
    payload: { merchantId },

    type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.MERCHANT_ITEM_DISPLAY_PREFERENCE.FETCH.START,
});

export const promoteItemDisplayPreference = (collectionId: string, merchantId: string, index: number) => ({
    payload: { collectionId, merchantId, index },

    type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.IITEMDISPLAYPREFERENCE.PROMOTE.START,
});

export const editMerchantItemDisplayPreference = (
    merchantId: string,
    id: string,
    displayPreference: IMerchantDisplayPreference
) => ({
    payload: { merchantId, id, displayPreference },

    type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.IITEMDISPLAYPREFERENCE.MERCHANT_EDIT.START,
});

export const editMerchantLocalItemDisplayPreference = (
    id: string,
    index: number,
    displayPreference: IDisplayPreference
) => ({
    payload: { id, index, displayPreference },

    type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.IITEMDISPLAYPREFERENCE.MERCHANT_LOCAL_EDIT.START,
});

export const deleteMerchantItemDisplayPreference = (
    collectionId: string,
    merchantId: string,
    id: string,
    index: number
) => ({
    payload: { collectionId, merchantId, id, index },

    type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.IITEMDISPLAYPREFERENCE.MERCHANT_DELETE.START,
});

export const completeUpdatingDisplayPreferences = (error = false) => ({
    error,
    type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.FETCH.COMPLETED,
});

export const initCurrentView = (currentViewName: string, currentView: List<Map<string, any>>) => ({
    payload: {
        currentViewName,
        currentView,
    },
    type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.CURRENT_VIEW.INIT,
});

interface IChangeCurrentView {
    name?: string;
    data?: List<Map<string, any>>;
}
export const changeCurrentView = ({ name, data }: IChangeCurrentView) => ({
    payload: {
        currentViewName: name,
        currentView: data,
    },
    type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.CURRENT_VIEW.CHANGE,
});

export const setViewToDefault = (collectionId: string) => ({
    payload: { collectionId },
    type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.CURRENT_VIEW.RESET,
});
